import React from 'react';
import { StatementSlide } from './components/StatementSlide';
import { AnnotatedScreenSlide } from './components/AnnotatedScreenSlide';
import { ProductSlide } from './components/ProductSlide';
import { DataDepthSlide } from './components/DataDepthSlide';
import { CompetitionSlide } from './components/CompetitionSlide';
import { UserProductSlide } from './components/UserProductSlide';
import { FlywheelSlide } from './components/FlywheelSlide';
import { TractionSlide } from './components/TractionSlide';
import { GrowthSlide } from './components/GrowthSlide';
import { RevenueSlide } from './components/RevenueSlide';
import { TeamSlide } from './components/TeamSlide';
import { AdvisorsSlide } from './components/AdvisorsSlide';
import { AskSlide } from './components/AskSlide';
import { AppendixDividerSlide } from './components/AppendixDividerSlide';
import { AppendixScoringSlide } from './components/AppendixScoringSlide';
import { AppendixAudioSlide } from './components/AppendixAudioSlide';
import { AppendixLLMSlide } from './components/AppendixLLMSlide';
import { Appendix3DSlide } from './components/Appendix3DSlide';
import { AppendixCartographySlide } from './components/AppendixCartographySlide';
import { AppendixSidewalkSlide } from './components/AppendixSidewalkSlide';
import { MoatSlide } from './components/MoatSlide';
export function App() {
  return <main className="w-full bg-[#0d1520]" data-id="element-0">
      <StatementSlide data-id="element-1" />
      <AnnotatedScreenSlide data-id="element-2" />
      <ProductSlide data-id="element-3" />
      <DataDepthSlide data-id="element-4" />
      <CompetitionSlide data-id="element-5" />
      <UserProductSlide data-id="element-6" />
      <FlywheelSlide data-id="element-7" />
      <TractionSlide data-id="element-8" />
      <GrowthSlide data-id="element-9" />
      <RevenueSlide data-id="element-10" />
      <TeamSlide data-id="element-11" />
      <AdvisorsSlide data-id="element-12" />
      <AskSlide data-id="element-13" />
      <AppendixDividerSlide data-id="element-14" />
      <AppendixScoringSlide data-id="element-15" />
      <AppendixAudioSlide data-id="element-16" />
      <AppendixLLMSlide data-id="element-17" />
      <Appendix3DSlide data-id="element-18" />
      <AppendixCartographySlide data-id="element-19" />
      <AppendixSidewalkSlide data-id="element-20" />
      <MoatSlide data-id="element-21" />
    </main>;
}